/* eslint-disable */

import CryptoJS from "crypto-js";
import { encode } from "js-base64";

//const APPID = "49381b94";
//const API_SECRET = "NWNkYjE0NDJjZTBjOTQxYWM0MzZmM2Ew";
//const API_KEY = "416c5e3288793c99d1102eea509d9b90";

const APPID = "147f5d41";
const API_SECRET = "NjdlOTEwZjYyMTFmYTc3YmJjMjgxMzkw";
const API_KEY = "f0c6427c6260a251418917dab7d1cbc7";
let loading = false;
export const audioPlayer = new AudioPlayer("/assets/js");
//audioPlayer.onPlay = () => {};

//audioPlayer.onStop = (audioDatas) => {};

function getWebSocketUrl(apiKey, apiSecret) {
  let url = "wss://tts-api.xfyun.cn/v2/tts";
  const host = location.host;
  const date = new Date().toGMTString();
  const algorithm = "hmac-sha256";
  const headers = "host date request-line";
  const signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/tts HTTP/1.1`;
  const signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
  const signature = CryptoJS.enc.Base64.stringify(signatureSha);
  const authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
  const authorization = btoa(authorizationOrigin);
  url = `${url}?authorization=${authorization}&date=${date}&host=${host}`;
  return url;
}

let ttsWS;

function connectWebSocket(text, callback, adPlayer = audioPlayer, mySpeed) {
  if (loading) {
    return;
  }
  loading = true;
  const url = getWebSocketUrl(API_KEY, API_SECRET);

  if ("WebSocket" in window) {
    ttsWS = new WebSocket(url);
  } else {
    alert("浏览器不支持WebSocket");
    return;
  }

  if (!mySpeed) {
    mySpeed = +50;
  }

  ttsWS.onopen = (e) => {
    adPlayer.start({
      autoPlay: true,
      sampleRate: 16000,
      resumePlayDuration: 1000,
    });

    // x4_xiaoyuan
    // x4_xiaoguo
    // x4_panting
    //发音人 xiaoyan, aisbabyxu, aisjinger, aisxping ,aisjiuxu
    let params = {
      common: { app_id: APPID },
      business: {
        aue: "raw",
        auf: "audio/L16;rate=16000",
        vcn: "x4_panting",
        //vcn: "xiaoyan",
        speed: mySpeed,
        volume: +80,
        pitch: +50, //音高
        bgs: 0,
        tte: "UTF8",
      },
      data: {
        status: 2,
        text: encode(text),
      },
    };
    ttsWS.send(JSON.stringify(params));
  };

  ttsWS.onmessage = (e) => {
    loading = false;

    let jsonData = JSON.parse(e.data);

    //code:0 正常状态

    // 合成失败
    if (jsonData.code !== 0) {
      console.error(jsonData);
      return;
    }

    adPlayer.postMessage({
      type: "base64",
      data: jsonData.data.audio,
      isLastData: jsonData.data.status === 2,
    });

    if (jsonData.code === 0 && jsonData.data.status === 2) {
      ttsWS.close();
      if (callback) {
        callback();
      }
    }
  };

  ttsWS.onerror = (e) => {
    console.error(e);
  };

  ttsWS.onclose = (e) => {
    // console.log(e);
  };
}

export default {
  connectWebSocket: connectWebSocket,
  audioPlayer: audioPlayer,
};
